module.exports = function() {
  return new Worker(__webpack_public_path__ + "fa28d59985656be71836.worker.js");
};